"use client";

import { useSubmitConsultation } from "@/hooks/useContent";
import type { Locale } from "@/types/insights";
import { useLocale } from "next-intl";
import { useState } from "react";

/** Newsletter sign-up band — files an email subscriber into the leads inbox. */
export default function NewsletterBand() {
  const ar = (useLocale() as Locale) === "ar";
  const submit = useSubmitConsultation();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    try {
      await submit.mutateAsync({ email, targetType: "newsletter", subject: ar ? "اشتراك في النشرة" : "Newsletter subscription" });
      setSent(true);
    } catch {
      // keep the form so the user can retry
    }
  }

  return (
    <section className="bg-accent px-6 py-20 text-white md:py-28">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="font-bebas text-[clamp(2rem,5vw,3.6rem)] uppercase leading-tight">
          {ar ? "احصل على تحديثاتنا أولاً" : "Get our updates first"}
        </h2>
        {sent ? (
          <p className="mt-6 text-white/85">{ar ? "تم الاشتراك — شكراً لك!" : "Subscribed — thank you!"}</p>
        ) : (
          <form onSubmit={onSubmit} className="mx-auto mt-8 flex max-w-md flex-col gap-3 sm:flex-row">
            <input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={ar ? "البريد الإلكتروني" : "Email address"}
              className="flex-1 border border-white/40 bg-transparent p-3 text-sm text-white outline-none placeholder:text-white/60 focus:border-white"
            />
            <button type="submit" disabled={submit.isPending} className="bg-white px-8 py-3 text-[12px] font-semibold uppercase tracking-widest text-ash transition-transform hover:-translate-y-0.5 disabled:opacity-60">
              {submit.isPending ? (ar ? "جارٍ…" : "…") : ar ? "اشترك" : "Subscribe"}
            </button>
          </form>
        )}
        <p className="mt-4 text-[11px] uppercase tracking-widest text-white/60">
          {ar ? "تحديثات مرّة شهرياً. لا رسائل مزعجة." : "Monthly updates. No spam."}
        </p>
      </div>
    </section>
  );
}
